export default {
  total: state => state.total
};
